import { api } from './api.js'

/** GET /products?per_page=2000 */
export async function getProducts(params = {}) {
  const merged = { per_page: 2000, ...params }
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(merged).filter(([, v]) => v !== null && v !== undefined))
  ).toString()
  return api.get(`/products${qs ? '?' + qs : ''}`)
}

/** GET /price_lists/:id/products?per_page=2000 — products with client-specific prices */
export async function getPriceListProducts(priceListId, params = {}) {
  const merged = { per_page: 2000, ...params }
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(merged).filter(([, v]) => v !== null && v !== undefined))
  ).toString()
  return api.get(`/price_lists/${priceListId}/products${qs ? '?' + qs : ''}`)
}

/** GET /product_groups?company_id=X */
export async function getProductGroups(params = {}) {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined))
  ).toString()
  return api.get(`/product_groups${qs ? '?' + qs : ''}`)
}
